/**
 * Run Context Key Generation
 *
 * Generates a deterministic run identifier for question selection, state persistence,
 * and impression tracking. Same key = same run (resume state), different key = new run.
 *
 * Formula: mode:gameContext:tagSlug:partnerId:resolvedUserId:difficulty:runInstanceId
 */

export interface RunContext {
  mode: 'daily' | 'quiz' | 'endless';
  gameContext?: string | null;
  tagSlug?: string | null;
  partnerId?: string | null;
  difficulty: 'easy' | 'standard';
  runInstanceId?: string | null;
}

/**
 * Generates a deterministic run context key from run context and user identity.
 *
 * @param runContext - The run context (mode, gameContext, tagSlug, partnerId, difficulty)
 * @param resolvedUserId - The resolved user ID (authenticated UUID or anonymous UUID, never null)
 * @returns A deterministic string key identifying this run
 */
export function generateRunContextKey(runContext: RunContext, resolvedUserId: string): string {
  const parts = [
    runContext.mode,
    runContext.gameContext ?? '',
    runContext.tagSlug ?? '',
    runContext.partnerId ?? '',
    resolvedUserId,
    runContext.difficulty,
    runContext.runInstanceId ?? '',
  ];
  return parts.join(':');
}
